import React, { FC, useRef, useEffect, useState } from "react";
import { storyTellerLoad } from "./load";
import "./index.scss";

const VERSION = "10.7.1";

const URL = `https://content.usestoryteller.com/javascript-sdk/${VERSION}/dist/storyteller.min.js`;
const API_KEY = process.env.STORY_TELLER_API_KEY || "";

type StoryTellerType = "clips" | "stories";
type StoryTellerCellType = "round" | "square";

interface Props {
  categories?: string[];
  displayLimit?: number;
  type?: StoryTellerType;
  cellType?: StoryTellerCellType;
}

const STORY_HEIGHT: Record<
  StoryTellerType,
  Record<StoryTellerCellType, string>
> = {
  stories: {
    square: "300",
    round: "auto"
  },
  clips: {
    square: "300px",
    round: "300px"
  }
};

const StoryTeller: FC<Props> = ({
  categories = [],
  displayLimit = 10,
  type = "stories",
  cellType = "square"
}) => {
  const rowContainer = useRef<HTMLDivElement>(null);
  let Storyteller: any = useRef(null);
  const [isStorytellerInitialized, setIsStorytellerInitialized] = useState(
    false
  );
  const row = useRef<any>();
  const urlSafeCategories = categories ? categories.join("-") : "home";
  const id = `storyteller-${type}-row-${urlSafeCategories}`;

  const initStoryTeller = () => {
    if (
      isStorytellerInitialized ||
      Storyteller.current.sharedInstance.isInitialized
    ) {
      setIsStorytellerInitialized(true);
      return;
    }
    try {
      Storyteller.current.sharedInstance.initialize(API_KEY).then(() => {
        setIsStorytellerInitialized(true);
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    storyTellerLoad(URL).then(() => {
      // @ts-ignore
      Storyteller.current = window.Storyteller;
      initStoryTeller();
    });
  }, []);

  const initStoryTellerStoriesView = () => {
    row.current = new Storyteller.current.StorytellerStoriesRowView(
      id,
      categories
    );
    row.current.configuration = {
      ...row.current.configuration,
      displayLimit,
      cellType,
      preload: true
    };
  };

  const initStoryTellerClipsView = () => {
    row.current = new Storyteller.current.StorytellerClipsRowView(
      id,
      categories[0]
    );
    row.current.configuration = {
      ...row.current.configuration,
      displayLimit
    };
  };

  const initStoryTellerType: Record<StoryTellerType, () => void> = {
    clips: initStoryTellerClipsView,
    stories: initStoryTellerStoriesView
  };

  useEffect(() => {
    if (!isStorytellerInitialized) {
      return;
    }
    initStoryTellerType[type]();
    row.current.delegate = {
      onDataLoadComplete: (_: any, error: any, dataCount: number) => {
        if (error || dataCount === 0) {
          if (rowContainer && rowContainer.current) {
            rowContainer.current.style.display = "none";
          }
        }
      }
    };
  }, [id, categories, isStorytellerInitialized]);
  return (
    <div
      ref={rowContainer}
      className={`storyteller-wrap storyteller-${type} storyteller-cell-${cellType}`}
    >
      <div
        id={id}
        data-base-url={urlSafeCategories}
        style={{ height: STORY_HEIGHT[type][cellType] }}
      ></div>
    </div>
  );
};

export default StoryTeller;
